import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 七牛域名
    QI_NIU_DOMAINS: computed(() => (
      store.state.label.data.QI_NIU_DOMAINS
    )),
    // 文章状态
    STATUS: computed(() => (
      store.state.label.data.CASE?.STATUS
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
